import React from 'react'
import ReactMarkdown from "react-markdown";


import { CustomerText } from '../CustomerText'
import SearchCom from '../Components/SearchCom'
import TextInput from './Components/TextInput'
import Pagination from './Components/Pagination'
import Config from '../Config'
import Tag from './Components/Tag'
import Icons from './Images';
const { Language, platform, Pushgtagpiwikurl, Pushgtagdata } = Config()

const Symbol = {
    M1: '"',
    M2: ' ',
    M3: '"',
}


export default class Search extends React.Component {
    constructor(props) {
        super(props)
        this.state = {

        }
        this.timeout = null
    }

    shouldComponentUpdate(nextProps) {
        if (platform == 'Web') {
            if (nextProps?.className != this.props?.className || nextProps.searchText != this.props?.searchText) {
                return true
            }
            return false
        }
    }


    render() {
        let { fromPage, onLeft, toggleShowDetail } = this.props
        let isFromPage = fromPage == 'QuestionDetail'
        let tempText = CustomerText[Language]
        let { RouterDetail, toggleSearchQuestion, className, RouterSearch, routerName } = this.props
        let SymbolStr = Symbol[Language]
        return <div className="searchContainer">
            <SearchCom
                tempText={tempText}
                RouterSearch={RouterSearch}
                routerName={routerName}
                Content={({
                    searchText,
                    changeSearchText,
                    searchCount,
                    searchResultTop,
                    searchResultBottom,
                    currentPaginationIndex,
                    changePaginationIndex,
                    questionIndex,
                    isSubmitEditing = false,
                    totalPaginationNum,
                    maxLength,
                    searchResultAI
                }) => {
                    let searchResultFlag = Array.isArray(searchResultTop) && !!searchResultTop.length
                    let isHaveSearchResult = !!searchCount && searchResultFlag

                    let RenderSearchResult = () => {
                        return <div className="searchResultTitleListBox">
                            {
                                (platform == 'Web' ? searchResultTop.slice(0, 5) : searchResultTop).map((v, i) => {
                                    return <div
                                        key={i}
                                        onClick={() => {
                                            if (platform == 'Web') {
                                                changeSearchText({
                                                    isSubmitEditing: true,
                                                    callBack: () => {
                                                        RouterDetail({
                                                            type: 'hot',
                                                            tempData: v
                                                        })
                                                    }
                                                })
                                            } else {
                                                changeSearchText({ questionIndex: i })
                                            }
                                            Pushgtagpiwikurl('help_center_search', 'Help Center Search Page')
                                            Pushgtagdata('HelpCenter', 'Click Search Recommendation', 'HelpCenter_C_SearchRecommendation', false,
                                                [
                                                    {
                                                        customVariableKey: "HelpCenter_C_SearchRecommendation",
                                                        customVariableValue: v?.title
                                                    }
                                                ]
                                            )
                                        }}
                                        className="searchResultTitleList">
                                        <div className="searchResultTitleListText">{v?.title}</div>
                                    </div>
                                })
                            }
                        </div>
                    }

                    let RenderInput = () => {
                        return <TextInput
                            tempText={tempText}
                            fromPage={fromPage}
                            platform={platform}
                            maxLength={maxLength}
                            type="text"
                            value={searchText}
                            onChange={event => {
                                let value = event.target.value.replace(/^\s+/, "")
                                if (value.length > maxLength) return
                                changeSearchText({
                                    searchText: value,
                                    isSubmitEditing: false,
                                    isSearch: true,
                                    callBack: () => {
                                        if (!value.trim().length && platform == 'Web') {
                                            toggleSearchQuestion(false)
                                        }
                                    }
                                })
                            }}
                            onKeyPress={event => {
                                if (event.key === 'Enter') {
                                    if (platform == 'Web') {
                                        changeSearchText({
                                            isSubmitEditing: true,
                                            isClick: true,
                                            isSearch: true,
                                            isAiSearch: true,
                                            callBack: () => {
                                                platform == 'Web' && searchText.length ? toggleSearchQuestion(true) : () => { }
                                            }
                                        })
                                    } else {
                                        changeSearchText({
                                            isSubmitEditing: true,
                                            isClick: true,
                                            isSearch: true,
                                            questionIndex: -9999,
                                            isAiSearch: true
                                        })
                                    }
                                }
                            }}
                            onFocus={() => {
                                if (searchText) {
                                    changeSearchText({ isSubmitEditing: false })
                                }
                            }}
                            onBlur={() => {
                                if (platform == 'Web') {
                                    this.timeout && clearTimeout(this.timeout)
                                    this.timeout = setTimeout(() => {
                                        changeSearchText({ isSubmitEditing: true })
                                    }, 200)
                                }
                            }}

                            onImgClick={event => {
                                if (platform == 'Web') {
                                    changeSearchText({
                                        isSubmitEditing: true,
                                        isClick: true,
                                        isSearch: true,
                                        isAiSearch: true,
                                        callBack: () => {
                                            searchText.length && toggleSearchQuestion(true)
                                        }
                                    })


                                    Pushgtagpiwikurl('help_center', 'Help Center')
                                    Pushgtagdata('HelpCenter', 'Search Help Center', 'HelpCenter_C_Search', false,
                                        [
                                            {
                                                customVariableKey: "HelpCenter_C_SearchContent",
                                                customVariableValue: searchText
                                            }
                                        ]
                                    )
                                }
                            }}
                            className=""
                        ></TextInput>
                    }

                    let detail = (questionIndex >= 0 && searchResultTop[questionIndex]) || {}
                    return <>
                        <div className='serachInputWrap'>
                            {
                                platform == 'Mobile' && routerName.includes('QuestionDetail')
                                    ?
                                    RenderInput()
                                    :
                                    RenderInput()
                            }

                            {
                                platform == 'Web' && !isSubmitEditing && isHaveSearchResult && !!searchText &&
                                RenderSearchResult()
                            }
                        </div>
                        <Tag className={`${platform == 'Mobile' ? 'scroll' : ''}`}>

                            {
                                platform == 'Mobile' && !isSubmitEditing && isHaveSearchResult && !!!Object.keys(detail).length &&
                                RenderSearchResult()
                            }


                            {
                                (platform == 'Web' ? className == 'searchShow' : true) &&
                                <div className={className}>
                                    {/* mobile 导航使用 */}
                                    {
                                        (!!Object.keys(detail).length || (platform == 'Mobile' ? isSubmitEditing : true)) &&
                                        <div className="detailNavBox">
                                            <div className="detailNav" onClick={() => {
                                                onLeft('Search')
                                            }}>
                                                {
                                                    platform == 'Web' &&
                                                    <div className='aiArrowBox'>
                                                        <div className="arrowIcon rightArrow1" />
                                                    </div>
                                                }
                                                <div className="detailNavText1">{tempText?.text1}</div>
                                                <div className="arrowIcon rightArrow1" />
                                            </div>


                                            <div
                                                className="detailNav"
                                                onClick={() => {
                                                    if (Object.keys(detail).length) {
                                                        changeSearchText({ questionIndex: -9999 })
                                                    }
                                                }}
                                            >
                                                <div className={`detailNavText${!!Object.keys(detail).length ? '1' : '2'}`}>{tempText?.text38}</div>
                                                {
                                                    !!Object.keys(detail).length &&
                                                    <div className="arrowIcon rightArrow1" />
                                                }
                                            </div>

                                            {
                                                !!Object.keys(detail).length &&
                                                <div className="detailNav">
                                                    <div className="detailNavText2 detailNavText3" numberOfLines={1}>{detail?.title}</div>
                                                </div>
                                            }
                                        </div>
                                    }


                                    {
                                        (platform == 'Web' && className == 'searchShow' ? true : isSubmitEditing) &&
                                        (
                                            !!searchResultAI
                                                ?
                                                (
                                                    // !!!Object.keys(detail).length
                                                    // &&
                                                    <div className='serachContentWrap'>
                                                        {/* {
                                                            !!searchText &&
                                                            <div
                                                                className="searchLength"
                                                                dangerouslySetInnerHTML={{
                                                                    __html: Language == 'M1' ? `${tempText?.text39}${SymbolStr}${searchText}${SymbolStr}${tempText?.text40}${searchCount}${tempText?.text41}` : (
                                                                        Language == 'M2' ? `${tempText?.text39}${SymbolStr}${searchCount}${SymbolStr}${tempText?.text40}${SymbolStr}${searchText}${tempText?.text41}` :
                                                                            `${tempText?.text39} ${searchCount} ${tempText?.text40} ${searchText}${tempText?.text41}`
                                                                    )
                                                                }}
                                                            ></div>
                                                        } */}

                                                        {/* <div className="searchResultBox">
                                                            {
                                                                searchResultBottom.map((v, i, self) => {
                                                                    return <div
                                                                        key={i}
                                                                        onClick={() => {
                                                                            if (platform == 'Web') {
                                                                                changeSearchText({
                                                                                    callBack: () => {
                                                                                        RouterDetail({
                                                                                            type: 'hot',
                                                                                            tempData: v
                                                                                        })
                                                                                    }
                                                                                })
                                                                            } else {
                                                                                changeSearchText({ questionIndex: i })
                                                                            }
                                                                            Pushgtagpiwikurl('help_center_search', 'Help Center Search Page')
                                                                            Pushgtagdata('HelpCenter', 'Click Search Result', 'HelpCenter_C_SearchResult', false,
                                                                                [
                                                                                    {
                                                                                        customVariableKey: "HelpCenter_C_SearchResult",
                                                                                        customVariableValue: v?.title
                                                                                    }
                                                                                ]
                                                                            )
                                                                        }}
                                                                        className="searchResultList" style={{ borderBottomWidth: i == self.length - 1 ? '0px' : '1px' }}
                                                                    >
                                                                        <div className="searchResultListTitle">{v?.title}</div>
                                                                        {
                                                                            !!v?.summary &&
                                                                            <div
                                                                                className="searchResultListText"
                                                                                dangerouslySetInnerHTML={{
                                                                                    __html: v?.summary
                                                                                }}
                                                                            ></div>
                                                                        }
                                                                    </div>
                                                                })
                                                            }
                                                        </div>

                                                        <Pagination
                                                            changePaginationIndex={changePaginationIndex}
                                                            totalPaginationNum={totalPaginationNum}
                                                            currentPaginationIndex={currentPaginationIndex}
                                                        ></Pagination> */}

                                                        {/* <div
                                                            className="searchResultAI"
                                                            dangerouslySetInnerHTML={{
                                                                __html: searchResultAI
                                                            }}
                                                        ></div> */}
                                                        <div className='aiContentHeader'>
                                                            <img
                                                                src={Icons[`star-ai`]}
                                                                className='aiContentHeaderImg'></img>
                                                            <div className='aiContentHeaderText'>{tempText.text80}</div>
                                                        </div>
                                                        <ReactMarkdown
                                                            className="searchResultAI"
                                                            components={{
                                                                a: ({ node, ...props }) => (
                                                                    <a {...props} target="_blank" rel="noopener noreferrer">
                                                                        {props.children}
                                                                    </a>
                                                                ),
                                                            }}
                                                        >{searchResultAI}</ReactMarkdown>
                                                    </div>
                                                )
                                                :
                                                <div className="noMessageBox">
                                                    {
                                                        !!searchText &&
                                                        <div
                                                            className="searchLength"
                                                            dangerouslySetInnerHTML={{
                                                                __html: `${tempText?.text42}${SymbolStr}${searchText}${SymbolStr}${tempText?.text43}`
                                                            }}></div>
                                                    }
                                                </div>
                                        )
                                    }


                                    {
                                        !!Object.keys(detail).length
                                        &&
                                        <div className='questionContentBox'>
                                            <div className="contentTitle">{detail?.title}</div>
                                            {
                                                !!detail?.content &&
                                                <div className="contentWrap"
                                                    dangerouslySetInnerHTML={{
                                                        __html: detail?.content || detail?.summary
                                                    }}
                                                ></div>
                                            }
                                        </div>
                                    }
                                </div>
                            }
                        </Tag>
                    </>
                }}
            ></SearchCom>
        </div>
    }
}